/**
 * Where the app leaves the SPA: the hosted UI on login and logout, and the login page after an
 * unrecoverable auth failure.
 *
 * Kept as named helpers so callers (and their tests) never have to touch `window.location`,
 * which jsdom refuses to redefine.
 */
export const navigateTo = (url: string) => {
  window.location.assign(url);
};

export const redirectToLogin = () => {
  navigateTo("/login");
};
